import { FC, useContext, useMemo } from 'react';

import { Button, Dropdown, type MenuProps } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

import { GenericDataFormContext, QuotationInfoContext } from '../../../../../../../shared/contexts';
import { StepThreeFormContext } from '../../../../contexts/StepThreeForm';

import { QuotationStep } from '../../../../../../../shared/interfaces';

interface HeaderTabFireProps {
  id: number;
}

export const HeaderTabFire: FC<HeaderTabFireProps> = ({ id }) => {
  const { currentStep } = useContext(QuotationInfoContext);
  const { duplicateTab, tabs, setShowModal, setKeyTabToDelete } =
    useContext(StepThreeFormContext);
  const { userCanDeleteTabs } = useContext(GenericDataFormContext);
  
  const canNotDeleteTab = useMemo(() => tabs.length === 1 || !userCanDeleteTabs, [tabs, userCanDeleteTabs]);

  const onMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === '1') duplicateTab(id);

    if (e.key === '2') {
      setKeyTabToDelete(id);
      setShowModal(true);
    }
  };

  const items = [
    {
      key: '1',
      label: 'Duplicar',
    },
    {
      key: '2',
      label: 'Eliminar',
      danger: true,
      disabled: canNotDeleteTab,
    },
  ];

  return (
    <>
      Incendio Web {id}
      {currentStep === QuotationStep.THREE && (
        <Dropdown
          menu={{ items, onClick: onMenuClick }}
          trigger={['click']}
          arrow
        >
          <Button type='text' style={{ padding: 0, marginLeft: 10 }}>
            <MoreOutlined />
          </Button>
        </Dropdown>
      )}
    </>
  );
};
